import { useLanguage } from '../i18n/useLanguage';
import type { Language } from '../i18n/language';

const labels: Record<Language, { switchToTr: string; switchToEn: string; title: string }> = {
  tr: {
    switchToTr: 'Türkçe',
    switchToEn: 'English',
    title: 'Dil seçimi',
  },
  en: {
    switchToTr: 'Turkish',
    switchToEn: 'English',
    title: 'Language selector',
  },
};

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const copy = labels[language];

  return (
    <div
      className="ml-3 inline-flex items-center rounded-full border border-primary-100 bg-white p-1 dark:border-primary-700/70 dark:bg-gray-800"
      role="group"
      aria-label={copy.title}
    >
      <button
        type="button"
        onClick={() => setLanguage('tr')}
        className={`rounded-full px-3 py-1 text-xs font-semibold transition ${
          language === 'tr'
            ? 'bg-primary-600 text-white'
            : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
        }`}
        aria-pressed={language === 'tr'}
      >
        TR
      </button>
      <button
        type="button"
        onClick={() => setLanguage('en')}
        className={`rounded-full px-3 py-1 text-xs font-semibold transition ${
          language === 'en'
            ? 'bg-primary-600 text-white'
            : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
        }`}
        aria-pressed={language === 'en'}
      >
        EN
      </button>

      <span className="sr-only">
        {language === 'tr' ? copy.switchToEn : copy.switchToTr}
      </span>
    </div>
  );
};

export default LanguageSwitcher;
